export const DuesStatus = {
  Pending: 0,
  Paid: 1,
  Overdue: 2,
  Cancelled: 3,
  AwaitingApproval: 4,
};

export const DuesStatusNames = {
  0: 'Beklemede',
  1: 'Ödendi',
  2: 'Gecikmiş',
  3: 'İptal Edildi',
  4: 'Onay Bekliyor',
};

export const PaymentMethod = {
  Cash: 0,
  BankTransfer: 1,
  CreditCard: 2,
  Online: 3,
};

export const PaymentMethodNames = {
  0: 'Nakit',
  1: 'Banka Havalesi/EFT',
  2: 'Kredi Kartı',
  3: 'Online Ödeme',
};

export const BillingPeriodNames = {
  1: 'Aylık',
  2: 'Üç Aylık',
  3: 'Yıllık',
};

export const LogoPostStatusNames = {
  0: 'Gönderilmedi',
  1: "Logo'ya gönderildi",
  2: 'Logo atlandı',
  3: 'Logo başarısız',
};

export const BULK_DUES_JOB_STORAGE_KEY = 'duesBulkCreateJobId';

export const canEditDues = (status) =>
  status === DuesStatus.Pending || status === DuesStatus.Overdue;

export const canMarkPaid = (status) =>
  status === DuesStatus.Pending ||
  status === DuesStatus.Overdue ||
  status === DuesStatus.AwaitingApproval;

export const getDuesStatusChipSx = (status) => {
  switch (status) {
    case DuesStatus.Paid:
      return { backgroundColor: '#DFFFEA', color: '#17C653' };
    case DuesStatus.Overdue:
      return { backgroundColor: '#FFEEF3', color: '#F8285A' };
    case DuesStatus.Cancelled:
      return { backgroundColor: '#F5F5F5', color: '#666666' };
    case DuesStatus.AwaitingApproval:
      return { backgroundColor: '#FFF4E6', color: '#FF9800' };
    default:
      return { backgroundColor: '#E7EDF4', color: '#0E4D94' };
  }
};
